import type { SearchTileDensity } from 'components/SearchKit/SearchTiles/searchTileDensity'
import NumberRating from 'components/Common/NumberRating'
import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled, { css } from 'styled-components'
import { _searchTileContainerQueryUp } from './_MetaSearchTileBase'

const Container = styled.div<{ $density: SearchTileDensity }>`
  grid-area: content-secondary;
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  justify-content: space-between;
  width: 100%;

  align-items: flex-end;

  ${_searchTileContainerQueryUp.tablet} {
    align-self: stretch;
  }
`

const PricingContainer = styled.div<{ $anchorToBottom: boolean, $density: SearchTileDensity }>`
  display: flex;
  flex-direction: ${props => props.$density === 'compact' ? 'column' : 'row'};
  gap: ${props => props.$density === 'compact' ? rem(12) : rem(16)};
  ${props => props.$anchorToBottom && 'margin-top: auto;'}
  justify-content: flex-start;
  width: 100%;

  & > * {
    flex: ${props => props.$density === 'compact' ? '0 1 auto' : '1'};
  }

  ${_searchTileContainerQueryUp.tablet} {
    ${props => props.$density === 'compact' ?
      css`
        justify-content: flex-start;
      ` :
      css`
        justify-content: flex-end;
      `}
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    justify-content: flex-start;
  }

  ${_searchTileContainerQueryUp.desktopLarge} {
    ${props => props.$density === 'compact' ?
      css`
        justify-content: flex-start;
      ` :
      css`
        justify-content: flex-end;
      `}
  }
`

const RatingContainer = styled.div`
  display: none;

  ${_searchTileContainerQueryUp.tablet} {
    display: block;
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    display: none;
  }

  ${_searchTileContainerQueryUp.desktop} {
    display: block;
  }
`

interface Props extends PropsWithChildren {
  anchorPricingToBottom?: boolean
  callToAction?: ReactElement
  rating?: App.OfferRating
  /**
   * @default default
   */
  density?: SearchTileDensity
}

function _MetaSearchTileContentSecondary({
  children,
  anchorPricingToBottom = false,
  rating,
  density = 'default',
}: Props) {
  return <Container className={_MetaSearchTileContentSecondary.name} $density={density}>
    {rating && <RatingContainer>
      <NumberRating
        rating={rating.score}
        total={rating.reviewsTotal}
        variant="small"
        numberPosition="end"
      />
    </RatingContainer>}
    <PricingContainer $anchorToBottom={anchorPricingToBottom} $density={density}>{children}</PricingContainer>
  </Container>
}

export default _MetaSearchTileContentSecondary
